<template>
  <div>
    <header-component>
    </header-component>
    <div class="container-fluid mt--6">
      <div class="card">
      <div class="card-header">
        <h3 class="mb-0" style="text-transform:capitalize;">Product Units List</h3>
        <div class="col-lg-12 col-5 text-right">
          <base-button size="sm" type="primary" @click="createProductUnit">Add New</base-button>
        </div>

      </div>

      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="productUnits"
      >
        <el-table-column label="Product Unit" min-width="170px" prop="label" sortable></el-table-column>
        <el-table-column min-width="70px">
          <template slot-scope="scope">
            <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
               <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <el-dropdown-item command="edit">Edit</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>

    <el-dialog title="Add Product Unit" :visible.sync="addProductUnit">
      <add-product-unit @close="addProductUnit=false"></add-product-unit>
    </el-dialog>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import AddProductUnit from "./AddProductUnit";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addProductUnit: false
    };
  },

  computed: {
    ...mapGetters({
      productUnits: "product/getProductUnits",
      productUnit: "product/getProductUnit"
    })
  },
  mounted() {
    this.getProductUnits();
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    "add-product-unit": AddProductUnit,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "header-component": headerComponent
  },

  methods: {
    ...mapActions({
      getProductUnits: "product/getProductUnits",
      fetchProductUnit: "product/fetchProductUnit"
    }),
    ...mapMutations({
      setProductUnit: "product/setProductUnit",
      resetProductUnit: "product/resetProductUnit"
    }),
    handleAction(productUnit, command) {
      if (command === "edit") {
        this.fetchProductUnit(productUnit.productUnitId).then(res => {
          this.addProductUnit = true;
          this.setProductUnit(res);
        });
      }
    },
    createProductUnit() {
      this.resetProductUnit();
      this.addProductUnit = true;
    }
  }
};
</script>